<template>
  <div>
    <div class="pos_container_panel">
      <!--search area-->
      <el-form :inline="true" :model="searchForm" label-width="150px">
        <el-row style="padding-top: 2rem">
          <el-col>
            <el-form-item label="客户名称：" style="margin-bottom: 0; margin-left: 1rem">
              <el-input @click="showClientNamePop" readonly v-model="searchForm.client" placeholder="请选择"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider class="title-divider"></el-divider>
        <div class="border">
          <!--line8-->
          <el-row class="rowtop">
            <el-col>
              <el-form-item label="开通支付渠道" style="margin-bottom: 0;"></el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col>
              <el-form-item label="国内酒店：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.paymentType_D" :disabled="posshow">
                  <el-checkbox v-for="resource in paymentType" :label="resource.key" :key="resource.key" @change="handleCheckboxChange(resource,'D')">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col>
              <el-form-item label="港澳台：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.paymentType_O" :disabled="posshow">
                  <el-checkbox v-for="resource in paymentType" :label="resource.key" :key="resource.key" @change="handleCheckboxChange(resource,'O')">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col>
              <el-form-item label="国际酒店：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.paymentType_I" :disabled="posshow">
                  <el-checkbox v-for="resource in paymentType" :label="resource.key" :key="resource.key" @change="handleCheckboxChange(resource,'I')">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-footer style="float: right; padding: 20px">
        <el-button type="warning" v-if="this.btnshow == 2" @click="saveForm()">保存</el-button>
        <el-button type="warning" v-if="this.btnshow == 2" @click="btnStatus(false)">取消</el-button>
        <el-button type="warning" v-if="this.btnshow == 1" @click="btnStatus(true)">修改</el-button>
      </el-footer>
    </div>
    <ConfirmBoxs
    :centerDialogVisible="confirmFlag"
    :confirmMsg="confirmMsg"
    :icon="confirmIcon"
    @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList
    :customerDialogVisible="clientListFlag"
    @setCustomerFlag="setCustomerFlag"
    @customerInfo="selectClient"
    ></ClientList>
  </div>
</template>
<script>
import { getOnlinePaymentType, saveOnlinePaymentType } from "@/api/platformData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "HBEOnlinePaymentType",
  inject: ['costCenter'],
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      searchForm: {
        client: "",
      },
      dataForm:{
        paymentType_D:["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"],
        paymentType_I:["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"],
        paymentType_O:["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"],
      },
      paymentType:[
        {key:"Alipay",value:"支付宝"},
        {key:"WapAliPay",value:"支付宝手机版"},
        {key:"H5WeiXinPay",value:"微信"},
        {key:"CNY_ProtocolPay",value:"快钱协议"},
        {key:"CNY_ProtocolPay_Master",value:"快钱协议-CTA"},
      ],
      posshow:true,
      btnshow: 0,
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
    };
  },
  methods: {
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.searchForm.client = item.customerName;
      this.searchRusult();
      this.posshow = true;
      this.btnshow = 1;
      if(this.clientListFlag){
        this.costCenter.selectClient(item);
      }
    },
    async searchRusult() {
      let customerParam = {
        params: {
          customerCode: this.hotelCustomerCode,
        },
      };
      await getOnlinePaymentType(customerParam)
        .then((res) => {
          if (res.code == 200) {
            let item = res.data;
            this.dataForm.paymentType_D = [];
            this.dataForm.paymentType_I = [];
            this.dataForm.paymentType_O = [];
            if(item.posOnlinePaymentTypeData.length > 0){
              item.posOnlinePaymentTypeData.forEach(element => {
                switch (element.producType) {
                  case "JD":
                    element.paymentType.split(",").forEach((val) => {
                      this.dataForm.paymentType_D.push(val);
                    });
                    break;
                  case "JI":
                    element.paymentType.split(",").forEach((val) => {
                      this.dataForm.paymentType_I.push(val);
                    });
                    break;
                  case "GAT":
                    element.paymentType.split(",").forEach((val) => {
                      this.dataForm.paymentType_O.push(val);
                    });
                    break;
                }
              });
            }else {
              this.dataForm.paymentType_D = ["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"];
              this.dataForm.paymentType_I = ["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"];
              this.dataForm.paymentType_O = ["Alipay","WapAliPay","H5WeiXinPay","CNY_ProtocolPay"];
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "获取失败,请重新选择客户";
            return;
          }
        })
        .catch(function (error) {
          console.log("POS 请求失败", error);
        });
    },
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    btnStatus(val) {
      if (val) {
        this.posshow = false;
        this.btnshow = 2;
      } else {
        this.searchRusult();
        this.posshow = true;
        this.btnshow = 1;
      }
    },
    saveForm() {
      let Param = {
        posOnlinePaymentTypeData:[
          {customerCode:this.hotelCustomerCode, producType:"JD", paymentType:this.dataForm.paymentType_D.toString()},
          {customerCode:this.hotelCustomerCode, producType:"JI", paymentType:this.dataForm.paymentType_I.toString()},
          {customerCode:this.hotelCustomerCode, producType:"GAT", paymentType:this.dataForm.paymentType_O.toString()},
        ]
      };
      saveOnlinePaymentType(Param)
        .then((res) => {
          console.log("save CostCenter信息", res);
        })
        .catch(function (error) {
          console.log("save CostCenter 请求失败", error.objError);
        });
      this.confirmFlag = true;
      this.confirmMsg = "保存成功";
      this.posshow = true;
      this.btnshow = 1;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    handleCheckboxChange(resource,value) {
      const paymentTypeMap = {
        D: this.dataForm.paymentType_D,
        I: this.dataForm.paymentType_I,
        O: this.dataForm.paymentType_O,
      };

      if (paymentTypeMap[value]?.includes("CNY_ProtocolPay_Master") && resource.key === "CNY_ProtocolPay_Master") {
        this.confirmFlag = true;
        this.confirmMsg = "使用快钱协议-CTA进行支付,必须提前配置成本中心,否则会导致无法下单.";
      }
    },
  },
};
</script>
  
<style scoped>
.pos_container_panel {
  /*padding: 0 16rem 4rem;*/
  padding-bottom: 15rem;
  padding-left: 10rem;
}

::v-deep .el-checkbox {
  margin-right: 30px!important;
}


</style>